import React from 'react'
import { isCompleteStatus, isLockedStatus, getRequirementDisplayData } from './utils'
import { buildArticleUrl } from './utils/urlUtils'
import { REQUIREMENT } from './utils/constants/levels'
import RequirementActionLinks from './RequirementActionLinks'
import LockIconSvg from '../../../assets/icons/icon-lock-status.svg'
import {
  RequirementCardStyled,
  RequirementHeader,
  RequirementTitle,
  StatusBadgeSmall,
  StatusBadgeText,
  StatusBadgeCheckmark,
  StatusBadgeLock,
  RequirementDescription,
  RequirementInfoBanner,
  RequirementInfoText,
  TextButton
} from './Styles/ProgressTracker.styles'

const RequirementCard = ({ requirement, activeLevel, shouldShowPATWarning }) => {
  const displayData = getRequirementDisplayData(activeLevel, requirement)
  const isComplete = isCompleteStatus(requirement.status)
  const isLocked = isLockedStatus(requirement.status)
  const isPATWithWarning = requirement.id === REQUIREMENT.PLAYING_ABILITY_TEST && shouldShowPATWarning

  return (
    <RequirementCardStyled hasWarning={isPATWithWarning}>
      {isPATWithWarning && (
        <RequirementInfoBanner>
          <RequirementInfoText>
            In order to enroll as a PGA Member, a passing score is still required.{' '}
            {displayData.infoLinkText && displayData.infoLinkUrl && (
              <TextButton
                as="a"
                href={buildArticleUrl(displayData.infoLinkUrl)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {displayData.infoLinkText}
              </TextButton>
            )}
          </RequirementInfoText>
        </RequirementInfoBanner>
      )}
      <RequirementHeader>
        <RequirementTitle>{displayData.name}</RequirementTitle>
        <StatusBadgeSmall backgroundColor={displayData.backgroundColor}>
          {isComplete && <StatusBadgeCheckmark color={displayData.color} />}
          {isLocked && <StatusBadgeLock src={LockIconSvg} alt="Locked" />}
          <StatusBadgeText textColor={displayData.color}>
            {displayData.label}
          </StatusBadgeText>
        </StatusBadgeSmall>
      </RequirementHeader>
      <RequirementDescription>
        {isPATWithWarning 
          ? 'Congratulations, you have qualifying scores and can advance to Level 1. You will still need to pass the PAT in order to enroll as a PGA of America Member by the end of Level 3.'
          : displayData?.message || ''
        }
        {!isPATWithWarning && displayData.infoLinkText && displayData.infoLinkUrl && (
          <>
            {' '}
            <TextButton
              as="a"
              href={buildArticleUrl(displayData.infoLinkUrl)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {displayData.infoLinkText}
            </TextButton>
          </>
        )}
      </RequirementDescription>
      <RequirementActionLinks
        displayData={displayData}
        requirementStatus={requirement.status}
      />
    </RequirementCardStyled>
  )
}

export default RequirementCard
